import Vue from 'vue';
import ReferredOrdersWithCount from '@/plugins/graphql/queries/v2/referral/referred-orders-with-count.gql';
import { standardDate } from '@/helpers/DateFormatter';
export default Vue.extend({
    apollo: {
        referredOrders: {
            query: ReferredOrdersWithCount,
            variables() {
                return {
                    referralLinkUuid: this.referralLink.uuid,
                };
            },
            update(data) {
                const referredOrders = data.referredOrdersWithCount.orders.edges;
                const referredOrdersNode = (referredOrder) => {
                    return referredOrder.node;
                };
                return referredOrders.map(referredOrdersNode);
            },
        },
    },
    props: {
        referralLink: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            referredOrders: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.referredOrders.length >= 1) {
                return self.referredOrders.map((referredOrder) => {
                    return {
                        referralId: self.referralLink.id,
                        referralName: self.referralLink.name,
                        referralCode: self.referralLink.code,
                        transactionNumber: referredOrder.transactionNumber,
                        productName: referredOrder.firstItem.productName,
                        customerName: `${referredOrder.firstName} ${referredOrder.lastName}`,
                        totalAmount: referredOrder.grandTotal,
                        paymentName: referredOrder.paymentOption.paymentName,
                        orderDate: self.formattedPlacedAt(referredOrder.orderStatus.placedAt),
                    };
                });
            }
            return [];
        },
    },
    methods: {
        formattedPlacedAt(date) {
            return standardDate(date);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                referredOrders: self.dataForCsv,
            });
        }
    },
});
